<template>
  <div class="loginImg">
    <div class="mark"></div>
    <div class="loginBox">
      <!-- 登录框 -->
      <div class="container">
        <div class="drop">
          <div class="content">
            <h2>森威拍卖管理系统</h2>
            <form>
              <div class="inputBox">
                <el-input
                  type="text"
                  placeholder="账号"
                  v-model.trim="username"
                  clearable
                  size="large"
                />
              </div>
              <div class="inputBox">
                <el-input
                  type="password"
                  @keyup.enter.native="handleLogin"
                  placeholder="密码"
                  v-model.trim="password"
                  clearable
                  show-password
                  size="large"
                />
                <!-- # Rewiew -->
                <!-- <el-input type="password" @keyup.enter.native="enterLogin" placeholder="密码" v-model="password" clearable /> -->
              </div>
              <el-button
                style="width: 200px"
                size="large"
                type="info"
                @click="handleLogin"
                :loading="loading"
                >登 录</el-button
              >
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import store from "@/store";
// import { handleGetAllRouter } from '@/router/allRoutes'
import { ElMessage } from "element-plus";
import { login } from "@/api/login.js";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
export default {
  setup() {
    // newRouteschildrenrouter
    let breadcrumbsData = computed(() => store.getters.newRouteschildrenrouter);
    const appStore = useStore();
    let router = useRouter();
    let username = ref("");
    let password = ref("");
    const loading = ref(false);
    /**
     * 登录
     */
    const handleLogin = () => {
      if (username.value.trim() === "" || password.value.trim() === "") {
        ElMessage({
          message: "账号和密码不能为空",
          type: "warning",
        });
        return;
      } else {
        Login();
      }
    };
    // 调用登录接口
    const Login = async () => {
      if (loading.value) {
        return;
      }
      loading.value = true;
      let res;
      try {
        res = await appStore.dispatch("handleLogin", {
          username: username.value,
          password: password.value,
        });
      } catch (error) {
        loading.value = false;
      }

      loading.value = false;
      // let res = await login({
      //   username: username.value,
      //   password: password.value,
      // });
      if (res.success) {
        router.push(breadcrumbsData.value[0].path);
        ElMessage({ message: "登录成功", type: "success" });
      } else {
        ElMessage({ message: res, type: "error" });
      }
    };

    return {
      username,
      password,
      handleLogin,
      Login,
      loading,
      //   GetAuthorInfo,
      // enterLogin
    };
  },
};
</script>

<style scoped lang="scss">
:deep(.is-focus) {
  box-shadow: none;
}

.loginImg {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-image: url(@/assets/bgc.png);
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;

  .mark {
    position: absolute;
    width: 100%;
    height: 100vh;
    background-color: #342a3c;
    opacity: 0.5;
    background-color: rgba(138, 208, 140, 0.077);
    /* 使用 rgba 来设置颜色和透明度 */
    backdrop-filter: blur(10px);
    /* 设置毛玻璃效果的模糊程度 */
  }
}

//  # Rewiew 层级结构

.loginBox {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* 登录框 */
.container .drop {
  position: relative;
  width: 450px;
  border-radius: 40px;
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  background-color: #fefefe34;
  backdrop-filter: blur(14px);
}

// 登录框鼠标移入
// .container .drop:hover {
//   cursor: pointer;
//   border-radius: 20px;
//   backdrop-filter: blur(0px);
// }

.container .drop .content {
  position: relative;
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 20px 40px;
}

.container .drop .content h2 {
  color: #ffffff;
  font-size: 2em;
  position: relative;
  font-family: serif;
  font-weight: 700;
  display: block;
}

.container .drop .content form {
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  align-items: center;
}

input {
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
}

input::placeholder {
  color: rgb(203, 203, 203);
  font-size: 14px;
  font-weight: normal;
}

.container .drop .content form .inputBox {
  position: relative;
  width: 248px;
  border-radius: 2px;
}

.container .drop .content form .inputBox input {
  width: 100%;
  height: 34px;
  padding-left: 10px;
  line-height: 34px;
  border: none;
  outline: none;
  background: transparent;
  font-size: 16px;
}

:deep(.el-button) {
  width: 80px;
  // height: 38px;
  // color: #c3c1c1;
  border: none;
  transition: background 0.5s;
  // background: linear-gradient(135deg, #698493, #292a3a);
  background: linear-gradient(242deg, #625c54, #3e87a2cc);
}

:deep(.el-button:hover) {
  color: #fff;
}

.register {
  color: rgb(226, 226, 226);
  font-size: 14px;
  margin-right: 20px;
}
</style>